// Per-page limit for 単語データ and 問題データ tables on subject detail page
export const SUBJECT_TABLE_PER_PAGE = 10;
